import localStore from '@theme/local-store'
import { Component } from '@theme/component'

class VehicleMake extends Component {
  constructor() {
    super()
    /** @type {(e: Event) => void} */
    this._onClick = this._onClick.bind(this)
    /** @type {(e: Event) => void} */
    this._onChange = this._onChange.bind(this)
    /** @type {(e: CustomEvent) => void} */
    this._onMakeChanged = this._onMakeChanged.bind(this)
    this._localStore = localStore
  }

  connectedCallback() {
    super.connectedCallback?.()
    this.addEventListener('click', this._onClick, { capture: true })
    this.addEventListener('change', this._onChange, { capture: true })
    document.addEventListener('vehicle-make:changed', this._onMakeChanged)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick, { capture: true })
    this.removeEventListener('change', this._onChange, { capture: true })
    document.removeEventListener('vehicle-make:changed', this._onMakeChanged)
    super.disconnectedCallback?.()
  }

  /**
   * @param {Event} e
   */

  _onClick(e) {
    const target = /** @type {Element|null} */ (
      e.composedPath?.()[0] ?? e.target
    )
    if (!(target instanceof Element)) return

    // Acepta click en cualquier elemento dentro de la tarjeta
    const el = target.closest('[data-make]')
    if (!el) return

    const make = el.getAttribute('data-make') || ''
    if (!make) return

    try {
      // Persistir make y validar vehículo almacenado
      this._localStore.set('vehicle_make', make)
      // UI: marcar make seleccionado
      this._setSelectedMake(make)

      let v = this._localStore.get('vehicle', null)
      if (typeof v === 'string') {
        try {
          v = JSON.parse(v)
        } catch (_) {}
      }
      if (v && typeof v === 'object' && v.make && v.make !== make) {
        this._localStore.remove('vehicle')
        document.dispatchEvent(
          new CustomEvent('vehicle:changed', {
            detail: { make },
            bubbles: true,
          })
        )
      }

      // Notificar cambio de make
      document.dispatchEvent(
        new CustomEvent('vehicle-make:changed', {
          detail: { make },
          bubbles: true,
        })
      )
    } catch (err) {
      console.error('VehicleMake click handler error:', err)
    }
  }

  /**
   * @param {Event} e
   */
  _onChange(e) {
    const target = /** @type {Element|null} */ (
      e.composedPath?.()[0] ?? e.target
    )
    if (!(target instanceof Element)) return

    // Alternativa: <select data-make-select>
    if (target.matches('select[data-make-select]')) {
      const value = /** @type {HTMLSelectElement} */ (target).value
      if (!value) return
      try {
        const make = value
        this._localStore.set('vehicle_make', make)
        // UI: marcar make seleccionado desde <select>
        this._setSelectedMake(make)

        let v = this._localStore.get('vehicle', null)
        if (typeof v === 'string') {
          try {
            v = JSON.parse(v)
          } catch (_) {}
        }
        if (v && typeof v === 'object' && v.make && v.make !== make) {
          this._localStore.remove('vehicle')
          document.dispatchEvent(
            new CustomEvent('vehicle:changed', {
              detail: { make },
              bubbles: true,
            })
          )
        }

        document.dispatchEvent(
          new CustomEvent('vehicle-make:changed', {
            detail: { make },
            bubbles: true,
          })
        )
      } catch (err) {
        console.error('VehicleMake change handler error:', err)
      }
    }
  }

  /**
   * Maneja el evento global `vehicle-make:changed` para sincronizar la UI.
   * @param {CustomEvent} e
   */
  _onMakeChanged(e) {
    const detail = /** @type {{ make?: string }} */ (e.detail || {})
    if (detail?.make) {
      this._setSelectedMake(detail.make)
    }
  }

  /**
   * Marca el make seleccionado y limpia selecciones previas.
   * Aplica solo sobre nodos con clase `.vehicle-make` para evitar colisiones
   * con otros elementos que comparten `data-make`.
   * @param {string} make
   */
  _setSelectedMake(make) {
    try {
      // Limpiar selección previa
      document
        .querySelectorAll('.vehicle-make.selected')
        .forEach((n) => n.classList.remove('selected'))
      document
        .querySelectorAll('vehicle-make-component.selected')
        .forEach((n) => n.classList.remove('selected'))
      // Marcar todos los nodos de la lista de makes que representen este make
      document
        .querySelectorAll(`.vehicle-make[data-make="${CSS.escape(make)}"]`)
        .forEach((n) => {
          n.classList.add('selected')
          const comp = n.closest('vehicle-make-component')
          if (comp) comp.classList.add('selected')
        })
    } catch (_) {
      // noop
    }
  }
}

if (!customElements.get('vehicle-make-component')) {
  customElements.define('vehicle-make-component', VehicleMake)
}
